import React, { useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { withRouter } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import * as actions from '../actions'
import { Button, Input, Picker } from '../../root/components/common'
import { useState } from 'react'
import { isEmailString } from '../../../utils'
import { enqueueSnackbar } from '../../root/actions'
import DoneIcon from '@material-ui/icons/Done'
import CancelIcon from '@material-ui/icons/CancelOutlined'

const useStyles = makeStyles(theme => ({
    modalButtons: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: 15
    },
    input: {
        marginTop: 15
    },
    emailRow: {
        position: 'relative'
    },
    doneIcon: {
        color: theme.active,
        position: 'absolute',
        top: 25,
        right: -34
    },
    cancelIcon: {
        color: theme.warning,
        position: 'absolute',
        top: 25,
        right: -34
    },
    rolePickerTitle: {
        marginTop: 20
    }
}))

function AddFromCustomerModal(props){
    const classes = useStyles()
    const dispatch = useDispatch()

    const {
        setOpen,
        roles
    } = props

    const [emails, setEmails] = useState([''])
    const [roleId, setRoleId] = useState(roles[0].id)

    const { emailsMembership } = useSelector(state => state.userManagement)
    const { locale } = useSelector(state => state.main)

    const onChangeEmail = (emails, idx) => (value) => {
        const newEmails = [...emails]
        newEmails[idx] = value
        setEmails(newEmails)
    }

    const areEmailsValid = (emails) => {
        let ok = true
        emails.forEach(email => {
            if (email === '') {
                ok = false
                dispatch(enqueueSnackbar({
                    message: locale.userManagement.emailIsEmpty,
                    options: {
                        variant: 'warning'
                    }
                }))
            } else if (!isEmailString(email)) {
                ok = false
                dispatch(enqueueSnackbar({
                    message: `${email} ${locale.userManagement.isNotEmail}`,
                    options: {
                        variant: 'warning'
                    }
                }))
            }
        })
        return ok
    }

    const onVerifyEmails = (emails) => {
        if (areEmailsValid(emails)) {
            dispatch(actions.usersCheckMembershipRequest(emails))
        }
    }

    const onAddUsers = (users, roleId) => {
        // const body 
        dispatch(actions.usersAddToCustomerRequest({
            users: users.map(user => ({
                user_id: user.user_id,
                role_id: roleId,
                email: user.email
            }))
        }))
        setOpen(false)
    }

    useEffect(() => {
        return () => {
            dispatch(actions.usersCheckMembershipSuccess(null))
        }
    }, [])

    return (
        <React.Fragment>
            <div>
                {locale.userManagement.fillInEmail}
            </div>
            <div>
                {locale.userManagement.onlyToYourOrg}
            </div>
            <div className={classes.emailRow}>
                {emails.map((email, idx) => (
                    <React.Fragment key={idx}>
                        <Input
                            className={classes.input}
                            disabled={emailsMembership !== null && emailsMembership[email] && emailsMembership[email].membership === true}
                            label={locale.common.email}
                            type='text'
                            setValue={onChangeEmail(emails, idx)}
                            value={email}
                        />
                        {emailsMembership !== null && emailsMembership[email] && emailsMembership[email].membership === true &&
                            <DoneIcon className={classes.doneIcon}/>
                        }
                        {emailsMembership !== null && emailsMembership[email] && emailsMembership[email].membership === false &&
                            <CancelIcon className={classes.cancelIcon}/>
                        }
                    </React.Fragment>
                ))}
            </div>
            {emailsMembership !== null && Object.values(emailsMembership).some(data => data.membership === true) &&
                <div>
                    <div className={classes.rolePickerTitle}>
                        {locale.userManagement.chooseRole}
                    </div>
                    <Picker
                        onChange={setRoleId}
                        value={roleId}
                        options={roles.reduce((acc, role) => {
                            acc[role.id] = role.name
                            return acc
                        }, {})}
                    />
                </div>
            }
            <div className={classes.modalButtons}>
                {(emailsMembership === null || Object.values(emailsMembership).every(data => data.membership === false)) &&
                    <Button onClick={onVerifyEmails.bind(
                        this,
                        emails
                    )}>
                        {locale.userManagement.verify}
                    </Button>
                }
                {emailsMembership !== null && Object.values(emailsMembership).some(data => data.membership === true) &&
                    <Button onClick={onAddUsers.bind(
                        this,
                        Object.keys(emailsMembership)
                            .filter(email => emailsMembership[email].membership === true)
                            .map(email => ({
                                user_id: emailsMembership[email].user_id,
                                email: email
                            })),
                        Number(roleId))
                    }>
                        {locale.userManagement.add}
                    </Button>
                }
                <Button reverted onClick={setOpen.bind(this, false)}>
                    {locale.common.cancel}
                </Button>
            </div>
        </React.Fragment>
    )
}

export default withRouter(AddFromCustomerModal)
